import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";
import Icon from "@ant-design/icons";
import Icons from "assets/icons";
import React from "react";

const {RADIO, INPUT, TEXT_AREA, RADIO_BUTTON} = FIELD_TYPE;

const css = {xs: 24, sm: 24, md: 12, lg: 12, xl: 12};
const wrapperCol = {xs: 16, md: 16, lg: 16};
const labelCol = {xs: 8, md: 8, lg: 8};

export const FieldsConjunctival1: any[] = [
  {
    label: "Cương tụ",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Cương tụ"],
  },
  {
    label: "Không có nhãn cầu",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Không có nhãn cầu"],
  },
  {
    label: "Rách",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Rách"],
  },
  {
    label: "Sẹo bọng",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Bọng kết mạc"],
  },
  {
    label: "Xuất huyết dưới kết mạc",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Xuất huyết dưới kết mạc"],
  },
  {
    label: "Dị vật",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Dị vật"],
  },
  {
    label: "Khu trú",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Khu trú"],
  },
  {
    label: "Nhú",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Nhú"],
  },
  {
    label: "Mộng mỡ",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Mộng mỡ"],
  },
  {
    label: "Mộng thịt",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Mộng thịt"],
  },
  {
    label: "Nốt rộp",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Nốt rộp"],
  },
  {
    label:
      "Ghèn gỉ                                                                                                                            ",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    name: ["rightJsonValue", "CONJUNCTIVA", "Ghèn gỉ"],
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "CONJUNCTIVA", "show"],
    hide: true,
  },
];

export const FieldsConjunctival2: any[] = [
  {
    label: "Cương tụ",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Cương tụ"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Không có nhãn cầu",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Không có nhãn cầu"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Rách",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Rách"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Sẹo bọng",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Bọng kết mạc"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Xuất huyết dưới kết mạc",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Xuất huyết dưới kết mạc"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Dị vật",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Dị vật"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Khu trú",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Khu trú"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Nhú",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Nhú"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Mộng mỡ",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Mộng mỡ"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Mộng thịt",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Mộng thịt"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Nốt rộp",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Nốt rộp"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "Ghèn gỉ",
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "CONJUNCTIVA", "Ghèn gỉ"],
    value: false,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "CONJUNCTIVA", "show"],
    hide: true,
  },
];
const fieldsCommentLeft = [
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "CONJUNCTIVA", "Ghi chú"],
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
  },
];
const fieldsCommentRight = [
  {
    label: "Ghi chú",
    type: INPUT,

    name: ["rightJsonValue", "CONJUNCTIVA", "Ghi chú"],
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
  },
];
const fieldsCongestionRight: any[] = [
  {
    label: " ",
    type: RADIO_BUTTON,
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
    name: ["rightJsonValue", "CONJUNCTIVA", "Congestion_Option"],
    value: false,
    radioButtons: [
      {label: "Toàn bộ", value: "Toàn bộ"},
      {label: "Khu trú", value: "Khu trú"},
      {label: "Vùng rìa", value: "Vùng rìa"},
    ],
  },
];

const fieldsCongestionLeft: any[] = [
  {
    label: " ",
    type: RADIO_BUTTON,
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
    name: ["leftJsonValue", "CONJUNCTIVA", "Congestion_Option"],
    value: false,
    radioButtons: [
      {label: "Toàn bộ", value: "Toàn bộ"},
      {label: "Khu trú", value: "Khu trú"},
      {label: "Vùng rìa", value: "Vùng rìa"},
    ],
  },
];
export {
  fieldsCongestionRight,
  fieldsCongestionLeft,
  fieldsCommentRight,
  fieldsCommentLeft,
};
